import {
	Component,
	forwardRef,
	Input,
	OnInit
} from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { StateService } from '@uirouter/angular';

import { IImageData } from 'rev-shared/ui/image-selector/ImageSelector.Contract';
import { DialogService } from 'rev-shared/ui/dialog/Dialog.Service';

import { ThemeService } from 'rev-portal/branding/Theme.Service';

import { EditWebcastBaseSettingsComponent } from './EditWebcastBaseSettings.Component';
import { EditWebcastModel } from './EditWebcastModel';
import { EventRegistrationPreviewDialog } from '../eventRegistration/Dialog.Config';
import { WebcastPreviewService } from '../webcast/WebcastPreview.Service';

@Component({
	selector: 'edit-webcast-branding',
	templateUrl: './EditWebcastBranding.Component.html',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => EditWebcastBrandingComponent),
		multi: true,
	}],
	standalone: false
})

export class EditWebcastBrandingComponent extends EditWebcastBaseSettingsComponent implements OnInit {
	@Input() public webcast: EditWebcastModel;

	public logoImage: IImageData;
	public bannerImage: IImageData;
	public brandingDefaults;

	public brandingEnabled: boolean = false;

	public constructor (
		private readonly $state: StateService,
		public ThemeService: ThemeService,
		private readonly DialogService: DialogService,
		private readonly WebcastPreviewService: WebcastPreviewService
	) {
		super();
	}

	public ngOnInit(): void {
		const brandingSettings = this.ThemeService.getBaseSettings();

		this.brandingDefaults = {
			headerColor: brandingSettings.headerSettings.backgroundColor,
			headerFontColor: brandingSettings.headerSettings.fontColor,
			...brandingSettings.themeSettings
		};
	}

	public previewWebcast():void {
		this.WebcastPreviewService.webcastForm = this.webcast;
		this.WebcastPreviewService.fromPreviewButton = true;
		this.$state.go('portal.scheduledEvents.webcast.preview');
	}

	public previewGuestLogin(): void {
		this.DialogService.getDialog(EventRegistrationPreviewDialog).open({
			initialState: {
				webcast: this.webcast
			}
		});
	}
}
